import {makeStyles} from "@material-ui/core"

export default makeStyles(theme => ({
    container: {
        overflow: "auto",
        marginBottom: 30,
    },
    table: {
        minWidth: 700,
    },
    pagination: {
        minWidth: 700,
    }
}))